import { Box, CircularProgress, TextField } from "@mui/material";
import PasswordField from "../../components/PasswordField";
import AuthPageLayout from "../../components/auth/AuthPageLayout";
import LoginSideImage from '../../images/login/login-side.png';
import { useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Fetch from "../../services/Fetch";
import SnackbarAlert from "../../components/SnackBar";
import AuthContext from "../../context/AuthContext";
import useSnackBar from "../../hooks/UseSnackBar";
import { useWaits } from "../../hooks/UseWait";
import { buildLoginFormData } from "../../helper/LoginFormData";
import { useConstants } from "../../hooks/UseConstants";

const loginInputSx = {
    width: '100%',
    '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.85)' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
    '& .MuiInput-underline:before': { borderBottomColor: 'rgba(255,255,255,0.5)' },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#fff' },
    '& .MuiInput-underline:after': { borderBottomColor: '#fff' },
    '& .MuiInputBase-input': { color: '#fff' },
    '& .MuiIconButton-root': { color: 'rgba(255,255,255,0.85)' },
};

function Login() {
     const host = `${process.env.REACT_APP_LOCAL_HOST}`;
     const { language } = useConstants();
     const isAr = language === 'ar';
     const { wait } = useContext(AuthContext);
     const { openSnackBar, type, message, setSnackBar, setOpenSnackBar } = useSnackBar();
     const { sendWait, setSendWait } = useWaits();
     const [email, setEmail] = useState('');
     const [password, setPassword] = useState('');
     const navigate = useNavigate();
     const location = useLocation();
     const redirectAfterLogin = location.state?.from || '/home';

     const login = async () => {
          setSendWait(true);

          const formData = buildLoginFormData({
               email: email,
               password: password
          });
          let result = await Fetch(host + "/login", "POST", formData);

          if (result.status === 200) {
               localStorage.setItem('token', result.data.data.token);
               localStorage.setItem('language', result.data.data.user.language);
               localStorage.setItem('id', result.data.data.user.id);
               const u = result.data.data.user;
               if (u.account_role !== 'student') {
                    setSnackBar("error", "هذا الحساب ليس حساب طالب");
                    localStorage.removeItem('token');
                    setSendWait(false);
                    return;
               }
               if (!u.verified_at) navigate('/verify');
               else if (!u.major?.id) navigate('/onboarding');
               else navigate(redirectAfterLogin, { replace: true });
          } else {
               setSnackBar("error", "البريد الإلكتروني أو كلمة المرور غير صحيحة");
          }
          setSendWait(false);
     }

     return (
          <>
               {wait ? (
                    <Box className="w-full h-screen relative flex justify-center items-center">
                         <CircularProgress size={70} />
                    </Box>
               ) : (
                    <AuthPageLayout
                         sideImage={LoginSideImage}
                         sideTitle={isAr ? 'تعلّم بثقة مع Altus Academy' : 'Learn with confidence at Altus Academy'}
                         sideSubtitle={isAr ? 'منصة تعليمية حديثة تجمع بين الدورات والمسارات والشهادات في تجربة واحدة متكاملة.' : 'A modern platform combining courses, paths, and certificates in one seamless experience.'}
                         badge={isAr ? 'لوحة الطالب' : 'Student portal'}
                         title={isAr ? 'تسجيل الدخول' : 'Sign In'}
                         footer={(
                              <>
                                   <Box onClick={() => navigate('/forgot-password')} className="cursor-pointer hover:underline">
                                        {isAr ? 'نسيت كلمة المرور؟' : 'Forgot Password?'}
                                   </Box>
                                   <Box onClick={() => navigate('/register')} className="cursor-pointer hover:underline text-end">
                                        {isAr ? 'إنشاء حساب جديد' : 'Create account'}
                                   </Box>
                              </>
                         )}
                    >
                         <TextField onChange={(e) => setEmail(e.target.value)} label={isAr ? 'البريد الإلكتروني' : 'Email'} variant="standard" sx={loginInputSx} slotProps={{ htmlInput: { className: 'py-5' } }} />
                         <PasswordField onChange={(e) => setPassword(e.target.value)} value={password} label={isAr ? 'كلمة المرور' : 'Password'} variant="standard" sx={loginInputSx} />
                         <button type="button" onClick={login} className="auth-btn-primary">
                              {sendWait ? <CircularProgress size={20} color="inherit" /> : (isAr ? 'تسجيل الدخول' : 'Sign in')}
                         </button>
                         <button type="button" onClick={() => navigate('/home')} className="auth-btn-ghost">
                              {isAr ? 'تصفح كزائر بدون حساب' : 'Browse as guest'}
                         </button>
                    </AuthPageLayout>
               )}
               <SnackbarAlert open={openSnackBar} message={message} severity={type} onClose={() => setOpenSnackBar(false)} />
          </>
     );
}

export default Login;
